import { Col, Row } from "react-bootstrap";
import { ILicenseeReturnDetails } from "../../../api/ILicenseeReturns";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface LicenseeReturnDetailsProps {
  licenseeReturn: ILicenseeReturnDetails;
}

const LicenseeReturnDetails = ({
  licenseeReturn,
}: LicenseeReturnDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Received Date"}
            value={licenseeReturn.datereceived}
          />
          <EpaField label={"Closed Date"} value={licenseeReturn.closeddate} />
          <EpaField label={"Title"} value={licenseeReturn.title} />
          <EpaField label={"Decision"} value={licenseeReturn.decision} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField label={"Document Type"} value={licenseeReturn.doctype} />
          <EpaField
            label={"Document SubType"}
            value={licenseeReturn.docsubtype}
          />
          <EpaField
            label={"Document Category"}
            value={licenseeReturn.documentcategory}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Description (submitted by licensee)"}
            value={licenseeReturn.description}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Licensee Return Details"} content={bodyElements} />;
};

export default LicenseeReturnDetails;
